module.exports = __webpack_public_path__ + "static/media/29EUNOG19.18b2d719.jpg";